<div class="main-box">
  <div class="header-box ">
    <div class="search-section">
      <!-- <h2 class="mt-2 mb-2"> -->
        <ng-content  select="[header]"></ng-content>
      <!-- </h2> -->
      <div class="position-relative button-search-box">
        <ng-content class="xlx" select="[filterButtons]"></ng-content>
        <ng-container *ngIf="isSearchable">
          <div class="search-table">
            <i class="fa-solid fa-magnifying-glass search-icon"></i>
            <input type="text" class="form-control search-box" placeholder="Search" [(ngModel)]="queryParams"
              (ngModelChange)="queryParamsSubject.next(queryParams)" />
          </div>
        </ng-container>
        <ng-container *ngIf="(paginationPosition === 'top' || paginationPosition === 'both') && isPaginationEnable">
          <ng-container *ngTemplateOutlet="pagination"></ng-container>
        </ng-container>
        <ng-content class="xlx" select="[tooltip]"></ng-content>
        <ng-container *ngIf="resetFilters"><button (click)="onResetFilters()" type="button"
            class="btn btn-primary-datalist ms-3">
            <i class="fa fa-refresh me-1"></i>
            <span class="hidebuttonName">RESET</span>
          </button>
        </ng-container>
        <ng-container *ngIf="isPrintEnable">
          <button (click)="onBtnPrint()" type="button" class="btn btn-primary-datalist ms-3">
            <i class="uil uil-print"></i>
            <span class="hidebuttonName"> PRINT</span>
          </button>
        </ng-container>
        <ng-container *ngIf="isExportable">
          <button (click)="onBtnExport()" type="button" class="btn btn-primary-datalist ms-3">
            <i class="fa-solid fa-download"></i>
            <span class="hidebuttonName"> EXPORT</span>
          </button>
        </ng-container>
        <ng-container *ngIf="isDeletable">
          <button (click)="getSelectedRowsData()" [disabled]="numberOfSelectedRows === 0" type="button"
            class="btn btn-primary-datalist">
            <i class="uil uil-trash"></i>
            <span class="hidebuttonName"> DELETESELECTEDPRODUCTS</span>
          </button>
        </ng-container>
        <ng-container *ngIf="isDeleteAll">
          <button (click)="deleteAllData()" type="button" class="btn btn-primary-datalist">
            <i class="uil uil-trash"></i>
            <span class="hidebuttonName">DELETEALLPRODUCTS</span>
          </button>
        </ng-container>
        <ng-content class="xlx" select="[topButtons]"></ng-content>
        <div class="input-group my-auto dateRangeSelector" *ngIf="isDateRangeSelectionOn">
          <div class="input-group-text bg-primary text-white border-r-none">
            <i class="uil uil-calendar-alt"></i>
          </div>
          <input class="form-control flatpickr-input mw-25" type="text" (input)="onDateRangeSelect()"
            [(ngModel)]="dateRange" mwlFlatpickr mode="range" />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
      <div class="col-12" *ngIf="showGrid" #grid>
        <ag-grid-angular [gridOptions]="gridOptions" id="commonGrid" domLayout="autoHeight"
          class="ag-theme-material ag-text" [rowData]="rowData" [pagination]="isPaginationEnable"
          [suppressPaginationPanel]="true" [paginationPageSize]="perPage" [defaultColDef]="defaultColDef"
          [animateRows]="true" [rowDragManaged]="true" (rowDragEnd)="onRowDragEnd($event)"
          [suppressRowClickSelection]="true" [rowGroupPanelShow]="rowGroupPanelShow" [columnDefs]="columnDefs"
          (sortChanged)="onSortChange($event)" (dragStopped)="onColumnOrderChange()"
          (filterChanged)="onfilterChange($event)" (gridReady)="onGridReady($event)" [suppressExcelExport]="true"
          [rowSelection]="rowSelection" [loadingOverlayComponentParams]="{ gridCount: perPage > 3 ? perPage : 3 }"
          [suppressDragLeaveHidesColumns]="true" [overlayNoRowsTemplate]="'No Record Found'"
          (selectionChanged)="onSelectionChange()">
        </ag-grid-angular>
      </div>
    </app-loader>
    <div class="col-12 position-relative"
      *ngIf="(paginationPosition === 'bottom' || paginationPosition === 'both') && isPaginationEnable">
      <ng-container *ngTemplateOutlet="pagination"></ng-container>
    </div>
    <ng-template #pagination>
      <div class="card card-pagination">
        <div class="card-body">
          <div class="my-auto pagination-rounded perPageDatatable">
            <ngb-pagination [collectionSize]="collectionSize" [(page)]="currentPage" [maxSize]="6" [pageSize]="perPage"
              [rotate]="true" [ellipses]="true" [boundaryLinks]="true"
              (pageChange)="onPageClick($event)"></ngb-pagination>
            <h6 class="my-auto">Per Page</h6>
            <ng-select class="pagination-dorpdown" [items]="pageSizeOptions" [(ngModel)]="perPage"
              (change)="onPageSizeChanged()" [searchable]="false" [clearable]="false" [appendTo]="'body'"
              bindLabel="pageSize" bindValue="value">
            </ng-select>
            <div class="ms-auto">
              <h6 class="my-auto text-muted">
                <span>
                  {{ currentPage === 1 ? 1 : (currentPage - 1) * perPage + 1 }}
                </span>
                to
                <span>
                  {{
                  currentPage === 1
                  ? rowData?.length < perPage ? rowData?.length : perPage : (currentPage - 1) * perPage +
                    rowData?.length }} </span>
                    of
                    {{ collectionSize }}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
